export default "__VITE_ASSET__af11b99b__"